module.exports = __webpack_public_path__ + "img/msg.366417d0.png";